import { render, staticRenderFns } from "./PnetMessageDetail.vue?vue&type=template&id=6cbdc8a8"
import script from "./PnetMessageDetail.vue?vue&type=script&lang=js"
export * from "./PnetMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./PnetMessageDetail.vue?vue&type=style&index=0&id=6cbdc8a8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbdc8a8')) {
      api.createRecord('6cbdc8a8', component.options)
    } else {
      api.reload('6cbdc8a8', component.options)
    }
    module.hot.accept("./PnetMessageDetail.vue?vue&type=template&id=6cbdc8a8", function () {
      api.rerender('6cbdc8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pnetmessage/PnetMessageDetail.vue"
export default component.exports